import React, { useState } from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

import Arrow from "../../pages/Arrow";
import Generalsidebar from "../../pages/Generalsidebar";

const MainArticle = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  function handleArrowClick() {
    setShowSidebar(true);
  }

  const articles = [
    {
      image:
        "https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672457/img/how_to_treat_insomnia_pic_kdqco6.png",
      title: "HOW TO TREAT INSOMNIA",
      content:
        "Treating insomnia often involves a combination of lifestyle changes, behavioural strategies and in some cases, medical interventions. Here are some steps you can take to address insomnia...",
      link: "/treat",
    },
    {
      image:
        "https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672591/article_list_2_rjsnbh.png",
      title: "THREE HABITS TO MAKE YOU MENTALLY STRONG",
      content:
        "Cultivating mental strength involves adopting positive habits that enhance resilience, emotional well-being, and overall mental health. Here are habits that can help you build mental strength...",
      link: "/mental",
    },
    {
      image:
        "https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672607/Rectangle_502_og8x1y.png",
      title: "BENEFITS OF THERAPY",
      content:
        "Therapy, also known as counseling or psychotherapy, offers a wide range of benefits that contribute to improved mental health, emotional well-being, and overall quality of life. Let's explore some benefits of therapy that can help you grow...",
      link: "/benefit",
    },
    {
      image:
        "https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672607/Rectangle_502_og8x1y.png",
      title: "BENEFITS OF THERAPY",
      content:
        "Therapy, also known as counseling or psychotherapy, offers a wide range of benefits that contribute to improved mental health, emotional well-being, and overall quality of life. Let's explore some benefits of therapy that can help you grow...",
      link: "/benefit",
    },
    {
      image:
        "https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672607/Rectangle_502_og8x1y.png",
      title: "BENEFITS OF THERAPY",
      content:
        "Therapy, also known as counseling or psychotherapy, offers a wide range of benefits that contribute to improved mental health, emotional well-being, and overall quality of life. Let's explore some benefits of therapy that can help you grow...",
      link: "/benefit",
    },
    {
      image:
        "https://res.cloudinary.com/dtd0nwvyd/image/upload/v1700672607/Rectangle_502_og8x1y.png",
      title: "BENEFITS OF THERAPY",
      content:
        "Therapy, also known as counseling or psychotherapy, offers a wide range of benefits that contribute to improved mental health, emotional well-being, and overall quality of life. Let's explore some benefits of therapy that can help you grow...",
      link: "/benefit",
    },
    // Add more articles as needed
  ];

  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = articles
    .filter((article) =>
      article.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(
    articles.filter((article) =>
      article.title.toLowerCase().includes(searchTerm.toLowerCase())
    ).length / itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <Navbar />
      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>
      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div className="text-black ml-20 mt-2">
        <Link to="/mainresources">
          <button className="flex gap-1 px-4 py-2 rounded-xl w-fit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            Back
          </button>
        </Link>
      </div>
      <div className="mx-auto max-w-[900px] my-5 p-10 rounded-lg shadow-inner shadow-black">
        <div className="mx-10">
          <h1 className="text-3xl text-[#295700] font-serif font-bold py-5 text-center">
            OUR RECENT ARTICLES
          </h1>
          <div className="flex justify-center mb-4">
            <input
              type="text"
              placeholder="Search by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border p-2 mr-2"
            />
            <button
              onClick={() => {
                setCurrentPage(1); // Reset page when search term changes
              }}
              className="bg-[#295700] text-white px-4 py-2 rounded  hover:bg-green-700"
            >
              Search
            </button>
          </div>
        </div>
        <div className="bg-[#DCAE96] px-4 py-4 text-center">
          {currentItems.map((article, index) => (
            <div key={index} className="mb-8">
              <img
                src={article.image}
                // alt={article`${index + 1}`}
                className="w-[50%] ml-[200px] mb-4 text-center"
              />
              <div>
                <h2 className="text-xl text-[#295700] font-serif font-bold mb-2">
                  {article.title}
                </h2>
                <p>{article.content}</p>
              </div>
              <div className="mt-4">
                <Link to={article.link}>
                  <button className="border-2 border-[#295700] px-5 py-1 rounded-xl hover:bg-[#295700] hover:text-white">
                    READ MORE
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center m-8">
          {Array.from({ length: totalPages }, (_, index) => index + 1).map(
            (pageNumber) => (
              <button
                key={pageNumber}
                onClick={() => handlePageChange(pageNumber)}
                className="mx-2 px-3 py-1 border border-[#295700] rounded-full"
              >
                {pageNumber}
              </button>
            )
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MainArticle;
